<template>
  <a-config-provider :locale="chinese">
    <div id="febs">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import enquireScreen from './utils/device';
import chinese from 'ant-design-vue/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

export default {
  name: 'App',
  data() {
    return {
      chinese,
    };
  },
  created() {
    enquireScreen((isMobile) => {
      this.$store.commit('setting/setDevice', isMobile);
    });
  },
};
</script>
<style lang="less">
html,
body,
#app,
#febs {
  height: 100%;
  margin: 0;
}

.multi-page {
  margin: -24px 0 0;
}

.single-page {
  margin: 0;
}

.not-menu-page {
  background: #fff;
  padding: 16px 32px;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.ant-layout {
  min-height: calc(100vh - 0px);
}

.ant-layout-header,
.system-top-menu {
  height: 59px !important;
  line-height: 59px !important;
}

.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  background: #393e46 !important;
}

.page-tabs .ant-tabs-close-x {
  color: #fff !important;
  margin-left: 0.3rem !important;
}

.page-tabs:hover .ant-tabs-close-x {
  color: #f95476 !important;
}

.card-area {
  width: 100%;
}

.drawer-bootom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

.ant-drawer-body {
  padding-bottom: 3rem !important;
}
</style>
